import React from 'react'
import PropTypes from 'prop-types'
import Accordion from '../../../components/Accordion/Accordion'

const Row = ({ children }) => {
    return (
        <div className="w-full h-auto flex flex-row items-center justify-start gap-x-2">
            {children}
        </div>
    )
}

Row.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.element,
        PropTypes.object,
    ]),
}

const Circle = () => {
    return <div className="w-1 h-1 rounded-full bg-yellow" />
}

const EquipmentWarranty = ({ equipment, open, setOpen }) => {
    const renderContent = () => {
        return (
            <div className="w-full h-auto flex flex-col mt-4 gap-y-2">
                {equipment?.warranty?.full && (
                    <Row>
                        <Circle />
                        <p className="text-textDarkerGray font-normal text-sm">
                            {equipment.warranty.full || '-'}
                        </p>
                    </Row>
                )}
                {equipment?.warranty?.powertrain && (
                    <Row>
                        <Circle />
                        <p className="text-textDarkerGray font-normal text-sm">
                            {equipment.warranty.powertrain || '-'}
                        </p>
                    </Row>
                )}
                {equipment?.warranty?.battery && (
                    <Row>
                        <Circle />
                        <p className="text-textDarkerGray font-normal text-sm">
                            {equipment.warranty.battery || '-'}
                        </p>
                    </Row>
                )}
                {equipment?.warranty?.paint && (
                    <Row>
                        <Circle />
                        <p className="text-textDarkerGray font-normal text-sm">
                            {equipment.warranty.paint || '-'}
                        </p>
                    </Row>
                )}
                {equipment?.warranty?.tread && (
                    <Row>
                        <Circle />
                        <p className="text-textDarkerGray font-normal text-sm">
                            {equipment.warranty.tread || '-'}
                        </p>
                    </Row>
                )}
                {equipment?.warranty?.extra && (
                    <Row>
                        <Circle />
                        <p className="text-textDarkerGray font-normal text-sm">
                            {equipment.warranty.extra || '-'}
                        </p>
                    </Row>
                )}
            </div>
        )
    }

    const onIsOpen = () => {
        setOpen('warranty')
    }

    return (
        <Accordion
            text="Warranty"
            hasBorder={true}
            content={renderContent()}
            isEquipmentInfo
            forceClose={open}
            onIsOpen={onIsOpen}
        />
    )
}

EquipmentWarranty.propTypes = {
    equipment: PropTypes.object,
    open: PropTypes.bool,
    setOpen: PropTypes.func,
}

export default EquipmentWarranty
